export default "__VITE_ASSET__23073f17__"